import AscPrimaryCorrectAnswersCard, {
  AscPrimaryCorrectAnswersCardProps,
} from "./AscPrimaryCorrectAnswersCard/AscPrimaryCorrectAnswersCard";
import AscSecondaryCorrectAnswersCard, {
  AscSecondaryCorrectAnswersCardProps,
} from "./AscSecondaryCorrectAnswersCard/AscSecondaryCorrectAnswersCard";

export type AscCorrectAnswersCardProps =
  | (AscPrimaryCorrectAnswersCardProps & {
      type?: "primary";
    })
  | (AscSecondaryCorrectAnswersCardProps & {
      type: "secondary";
    });

export default function AscCorrectAnswersCard({
  type = "primary",
  ...props
}: AscCorrectAnswersCardProps) {
  switch (type) {
    case "secondary":
      return <AscSecondaryCorrectAnswersCard {...props} />;
    case "primary":
    default:
      return <AscPrimaryCorrectAnswersCard {...props} />;
  }
}
